import { render } from "./PointsPerTag.vue?vue&type=template&id=420ee5ae&ts=true"
import script from "./PointsPerTag.vue?vue&type=script&lang=ts"
export * from "./PointsPerTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__